import * as React from "react";
import Box from "@mui/material/Box";
import { PageTitle, SectionTitle } from "../../components/Typography";
import { DarkCard } from "../Card";
import { HeaderButton, HeaderButtons } from "./HeaderButtons";

export type Header = {
  title: string;
  buttons?: HeaderButton[];
}

export type Footer = {
  title: string;
  content: React.ReactNode;
}

export const PageLayout: React.FC<{
  header: Header;
  body: React.ReactNode;
  footer?: Footer;
}> = ({ header, body, footer }) => {
  const headerButtons = header.buttons || [];

  return (
    <>
      {/* header */}
      <Box sx={{ display: "flex", mb: 2, alignItems: "center" }}>
        <PageTitle title={header.title} />
        <Box sx={{ display: "flex", gap: 1, ml: "auto" }}>
          <HeaderButtons headerButtons={headerButtons} />
        </Box>
      </Box>
      {body}
      {footer &&
        <DarkCard>
          <SectionTitle title={footer.title} />
          {footer.content}
        </DarkCard>
      }
    </>
  );
}

